export enum IdleStateTypes {
  none = 0,
  warning = 1,
  expired = 2,
}
